
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 50 50"}},[_c('path',{attrs:{"d":"M50 22.5H27.5V0h-5v22.5H0v5h22.5V50h5V27.5H50z"}})])
      }
    
      }
    